import { render, staticRenderFns } from "./EducationalComponent.vue?vue&type=template&id=5cc57faa&scoped=true"
import script from "./EducationalComponent.vue?vue&type=script&lang=js"
export * from "./EducationalComponent.vue?vue&type=script&lang=js"
import style0 from "./EducationalComponent.vue?vue&type=style&index=0&id=5cc57faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc57faa",
  null
  
)

export default component.exports